import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { BulkVoiceover } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/bulk-voiceover")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <BulkVoiceover />
    </RouteGuard>
  ),
});
